import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import { type } from '../../utils/index.js';
import rgb2css from './rgb2css.js';
import css2rgb from './css2rgb.js';
Color.prototype.css = function (mode) {
  return rgb2css(this._rgb, mode);
};
var css = function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['css']));
};
chroma.css = css;
input.format.css = css2rgb;
input.autodetect.push({
  p: 5,
  test: function test(h) {
    if (!(arguments.length <= 1 ? 0 : arguments.length - 1) && type(h) === 'string' && css2rgb.test(h)) {
      return 'css';
    }
  }
});
export { css };